module.exports = __webpack_public_path__ + "img/logo2.b3466468.svg";